import { render, staticRenderFns } from "./payPage.vue?vue&type=template&id=8ae1c956&scoped=true&"
import script from "./payPage.vue?vue&type=script&lang=js&"
export * from "./payPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae1c956",
  null
  
)

export default component.exports